import qs from "qs";

export function stringifyQuery(query) {
    query = Object.fromEntries(
        Object.entries(query).map(([key, value]) => [
            key,
            value === true ? 1 : value === false ? 0 : value
        ])
    )
    const result = qs.stringify(query, {encodeValuesOnly: true});
    return result ? `?${result}` : '';
}
